import CoursesListRow from './courses-list-row'

export default CoursesListRow
